import type { Meta, StoryFn } from '@storybook/react';
import type { PropsWithChildren } from 'react';
import type { ButtonGroupProps } from './ButtonGroup';

import { ButtonGroup } from './ButtonGroup';

import { Button } from 'components/Buttons/Button';
import { Container } from 'storyComponents/Container';

const codeString = `
  <ButtonGroup reversed={reversed} stacked={stacked}>
    <Button variant={variant} onClick={onClickedFunction}>{children}</Button>
    <Button variant={variant} onClick={onClickedFunction}>{children}</Button>
  </ButtonGroup>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/ButtonGroup',
  component: ButtonGroup,
  argTypes: {
    children: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: ButtonGroup,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<ButtonGroupProps>>;

const Template: StoryFn<PropsWithChildren<ButtonGroupProps>> = (args) => (
  <Container>
    <ButtonGroup {...args} />
  </Container>
);

const defaultArgs: Partial<PropsWithChildren<ButtonGroupProps>> = {
  stacked: false,
  reversed: false,
  children: (
    <>
      <Button variant="primary">Primary button</Button>
      <Button variant="secondary">Secondary button</Button>
    </>
  ),
};

export const ButtonGroupExample = Template.bind({});
ButtonGroupExample.args = {
  ...defaultArgs,
};
